/**
 * GateSelectScreen (DQGMS · P-010)
 *
 * NEW screen — inserted between dashboard and cameraScan in the FSM.
 * Three big touch-friendly cards for the per-station quality gates:
 * QG1 / QG-Fan / QG2. Selection routed via props.onSelect(gateType) —
 * App.js records selectedGate and advances to the next state.
 *
 * B-Kansa is intentionally not here — it's a sampling audit with a
 * different lifecycle and now lives as its own app entry on the
 * AppSelectorScreen.
 */
import React from 'react';

const GATES = [
  {
    key: 'QG1',
    title: 'QG1 · Lower Unit',
    subtitle: 'Frame, compressors',
    color: '#2b7fd0',
    bg: '#e6f0fa',
    icon: '🔧',
  },
  {
    key: 'QG_FAN',
    title: 'QG Fan Section',
    subtitle: 'Off-line assembly — Notes only, no KO',
    color: '#0f7d8a',
    bg: '#e0f5f7',
    icon: '💨',
  },
  {
    key: 'QG2',
    title: 'QG2 · Final Assembly',
    subtitle: 'Panels, electrical, ready for test',
    color: '#7f5ac9',
    bg: '#f0e8fc',
    icon: '⚡',
  },
];

export default function GateSelectScreen({ onSelect, onBack }) {
  return (
    <div style={{ minHeight: '100vh', background: '#f4f7fa', padding: 20 }}>
      <div style={{ maxWidth: 720, margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
          {onBack && (
            <button
              onClick={onBack}
              style={{
                border: 'none', background: '#fff', borderRadius: 8,
                padding: '10px 14px', fontSize: 14, fontWeight: 600, cursor: 'pointer',
                color: '#4a596b', boxShadow: '0 1px 2px rgba(15,34,55,0.06)',
              }}
            >← Back</button>
          )}
          <div>
            <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: '#17253d' }}>Choose the gate</h1>
            <p style={{ margin: '4px 0 0 0', color: '#4a596b', fontSize: 13 }}>
              Which quality gate are you running for this unit?
            </p>
          </div>
        </div>

        <div style={{ display: 'grid', gap: 14 }}>
          {GATES.map(g => (
            <button
              key={g.key}
              onClick={() => onSelect(g.key)}
              style={{
                background: '#fff',
                border: `2px solid ${g.color}`,
                borderRadius: 12,
                padding: 20,
                display: 'flex',
                alignItems: 'center',
                gap: 16,
                cursor: 'pointer',
                textAlign: 'left',
                transition: 'transform 0.08s, box-shadow 0.08s',
                boxShadow: '0 2px 4px rgba(15,34,55,0.05)',
              }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 6px 14px rgba(15,34,55,0.12)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = '0 2px 4px rgba(15,34,55,0.05)'; }}
            >
              <div style={{
                width: 60, height: 60, borderRadius: 12,
                background: g.bg, color: g.color,
                display: 'grid', placeItems: 'center', fontSize: 28,
                flexShrink: 0,
              }}>{g.icon}</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 18, fontWeight: 700, color: g.color, marginBottom: 4 }}>{g.title}</div>
                <div style={{ fontSize: 13, color: '#4a596b' }}>{g.subtitle}</div>
              </div>
              <div style={{ fontSize: 24, color: g.color, fontWeight: 300 }}>›</div>
            </button>
          ))}
        </div>

        <div style={{ marginTop: 20, padding: 12, background: '#fff', borderRadius: 8, fontSize: 12, color: '#4a596b', border: '1px solid #e5eaf0' }}>
          <strong>Note:</strong> Fan Section uses <em>Notes</em> with Line Leader approval instead of KO,
          because a fan is inspected before it's mated to a chiller serial. Notes carry forward to Final Finishing.
        </div>
      </div>
    </div>
  );
}
